/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStyles, makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';

const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const ALIGN_ITEMS = ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'];
const JUSTIFY_CONTENT = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];

function generateStyles(theme: Theme) {
    const styles: any = {};

    SPACINGS.forEach((spacing) => {
        styles[`direction-column-spacing-${spacing}`] = {
            '& > :not(style)+:not(style)': {
                margin: theme.spacing(spacing, 0, 0, 0),
            },
        };

        styles[`direction-row-spacing-${spacing}`] = {
            '& > :not(style)+:not(style)': {
                margin: theme.spacing(0, 0, 0, spacing),
            },
        };
    });

    ALIGN_ITEMS.forEach((alignItems) => {
        styles[`align-items-${alignItems}`] = {
            alignItems,
        };
    });

    JUSTIFY_CONTENT.forEach((justifyContent) => {
        styles[`justify-content-${justifyContent}`] = {
            justifyContent,
        };
    });

    return styles;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
        },
        'direction-column': {
            flexDirection: 'column',
        },
        'direction-row': {
            flexDirection: 'row',
        },
        ...generateStyles(theme),
    });

export default makeStyles(styles, { name: 'MuiStack' });
